export default {
  name: 'default',
  fontFamily: "'Roboto', sans-serif",
  colors: {
    black: '#010101',
    white: '#fefefe',
    orange: '#eb8636',
    red: '#c00',
    silver: '#bcbcbc',
    darkSilver: '#4a4a4a',
    gray: '#999',
    darkGray: '#808080',
    green: '#59c00b',
    darkGreen: '#479908',
    blue: '#0086ff',
    darkBlue: '#005eb2'
  },
  palette: {
    primary: {
      base: '#0086ff',
      dark: '#005eb2',
      text: '#fefefe'
    },
    secondary: {
      base: '#59c00b',
      dark: '#479908',
      text: '#fefefe'
    },
    error: {
      base: '#c00',
      text: '#fefefe'
    },
    alert: {
      base: '#eb8636',
      text: '#fefefe'
    },
    text: {
      base: '#404040',
      light: '#999',
      scratched: ' #808080',
      lighter: '#bcbcbc',
      greyish: '#aaaaaa',
      lightest: '#fefefe',
      dark: '#010101',
      luContentLink: '#a400e1'
    },
    background: {
      base: '#f4f4f4',
      lighter: '#fff',
      darker: '#eee',
      whisper: '#e5e5e5',
      dark: '#999',
      primary: '#0086ff',
      primaryDark: '#0073db',
      luContentPrimary: '#a400e1'
    }
  },
  sizes: {
    header: '80px',
    hotLinks: {
      width: '56px',
      height: '56px'
    }
  }
};